import _get from 'lodash-es/get';
import { connect } from 'react-redux';

import {
  reviewProgramInitiate,
  getProgramInfoInitiate,
  clearProgramInfo,
} from '../../../../actions/programs';
import { getAllGroupsInitiate } from '../../../../actions/groups';
import { openErrorToast } from '../../../../reducers/uiLogic/index';
import CreatePlan from './CreatePlan';

const mapStateToProps = state => {
  const groupsData = _get(state, 'groups', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const companyId = _get(state, 'user.selectedWorkspace.company_id', '');
  const currentFlow = _get(state, 'user.currentFlow', 0);
  const programInfo = _get(state, 'programs.programInfo', {});
  const { programs = {} } = state;
  const { reviewProgramDetails = {} } = programs;

  return {
    companyId,
    currentFlow,
    selectedWorkspace,
    groupsData,
    programInfo,
    reviewProgramDetails,
    reviewingProgram:
      _get(state, 'apiState.REVIEW_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.REVIEW_PROGRAM.isIdle', true),
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  reviewProgram: payload => dispatch(reviewProgramInitiate(payload)),
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
  clearProgramInfo: () => dispatch(clearProgramInfo()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePlan);
